import React from 'react';
import { observer } from 'mobx-react';
import { Marker } from 'google-maps-react';

import OrangeDot from '../assets/orange-dot.png';
import GreenDot from '../assets/green-dot.png';
import BlueDot from '../assets/blue-dot.png';
import HeartIcon from '../assets/heart.png';

import UIStore from '../store/store';

class CustomMarker extends React.Component {
    getIcon() {
        const { point, likedPoints } = this.props;

        if (UIStore.isFavorited(point)) {
            return HeartIcon;
        }

        switch(point.type) {
            case 'city':
                return OrangeDot;
            case 'landmark':
                return GreenDot;
            case 'lakes':
                return BlueDot;
            default:
                return OrangeDot;
        }
    }

    render() { 
        const { google, point, onClick } = this.props;

        return (
            <Marker
                {...this.props}
                position={{ lat: point.lat, lng: point.lng }}
                onClick={(props) => onClick(props)}
                city={point}
                icon={{
                    url: this.getIcon(),
                    anchor: new google.maps.Point(0,0),
                    scaledSize: new google.maps.Size(12,12)
                }} 
            />
        )
    }
}

export default observer(CustomMarker)
